import  "./assets/css/reset.css";
import "./assets/css/style.css"
import "./assets/css/font-awesome/css/font-awesome.css"
import "./assets/js/style-switcher/color-switcher.css"
import "./assets/js/form/sky-forms.css";
import "./assets/js/lightbox/jquery.fancybox.css";
import "./assets/js/cubeportfolio/cubeportfolio.min.css";
import "./assets/js/revolutionslider/css/slider_main.css";
import "./assets/js/revolutionslider/rs-plugin/css/settings.css";
import "./assets/js/mainmenu/bootstrap.css";
import "./assets/js/mainmenu/fhmm.css";
import "./assets/js/mainmenu/sticky.css";
import "./assets/js/mainmenu/scrollbars.css";


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
